var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAuthenticated)?_c('v-container',{staticClass:"body pa-0",attrs:{"fluid":""}},[_c('router-view',{staticClass:"body"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }